"use strict";

exports.__esModule = true;
exports.DashboardScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Core = require("../../Core");
var _App = require("../../App");
var _DashboardCollection = require("../DashboardCollection");
var _API = require("../../API");
var _Device = require("../../Device");
var _Dashboard = require("../Dashboard/Dashboard");
var _DashboardDataProvider = require("../DashboardDataProvider");
var _DashboardNavbar = require("../DashboardNavbar");
var _DashboardToolbar = require("../DashboardToolbar");
var _DashboardRenderer = require("../DashboardRenderer");
var _Theme = require("../../Theme");
var _LayoutVisibility = require("../../ConfigurableLayout/LayoutVisibility");
var _UI = require("../../../Utils/UI");
var _ConfigurableLayout = require("../../ConfigurableLayout");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DashboardContainer = _styledComponents["default"].div.withConfig({
  displayName: "DashboardScreen__DashboardContainer",
  componentId: "sc-wuvurx-0"
})(["flex:1;display:flex;flex-direction:column;background:", ";& a{color:#000;&:hover{color:#000;}}.", " &{background:", ";& a{color:#fff;&:hover{color:#fff;}}}"], (0, _Theme.val)("ScreenBackground"), _core.Classes.DARK, (0, _Theme.val)("DarkScreenBackground"));
var DashboardWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DashboardScreen__DashboardWrapper",
  componentId: "sc-wuvurx-1"
})(["flex:1;"]);

/**
 * Screen which shows an individual dashboard.
 */
var DashboardScreen = exports.DashboardScreen = _Device.DeviceListContext.withContext((0, _Core.withTranslator)(function (props) {
  var devices = props.devices,
    translator = props.translator,
    match = props.match;
  var translate = translator.translate;
  var id = match.params.id;
  var dashboardCollection = (0, _react.useContext)(_DashboardCollection.DashboardCollectionContext);
  var update = dashboardCollection.update;
  var updateDashboardWidgetValue = function updateDashboardWidgetValue(config, path, fieldName, fieldValue) {
    var updatedConfig = (0, _ConfigurableLayout.updateFieldInLayoutElement)(config, path, fieldName, fieldValue);
    update(updatedConfig).then(function () {
      (0, _UI.showSuccessToaster)(translate("DashboardScreen.save.success", "Successfully updated the dashboard"));
    })["catch"](function (error) {
      console.error(error);
      (0, _UI.showErrorToaster)(translate("DashboardScreen.save.error", "An error has occurred while updating the dashboard"));
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_API.CollectionGetter, {
    collection: dashboardCollection,
    id: id,
    useCache: false
  }, function (_ref) {
    var _data$element, _data$element2;
    var data = _ref.data,
      error = _ref.error,
      reload = _ref.reload;
    if (error) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
        title: translate("DashboardScreen.title.error", "Error Loading Dashboard")
      }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
        title: translate("DashboardScreen.navbar.error", "Error Loading Dashboard")
      }), /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: error
      }));
    }
    if (!data) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
        title: translate("DashboardScreen.loadingText", "Loading {id} ...", {
          id: id
        })
      }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
        title: translate("DashboardScreen.loadingText", "Loading {id} ...", {
          id: id
        })
      }), /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null));
    }
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: data.name,
      "data-testid": "DashboardScreen"
    }, /*#__PURE__*/_react["default"].createElement(_LayoutVisibility.LayoutVisibility, {
      layoutRolesVisibilities: data == null || (_data$element = data.element) == null || (_data$element = _data$element.props) == null ? void 0 : _data$element.rolesVisibility,
      layoutUsersVisibilities: data == null || (_data$element2 = data.element) == null || (_data$element2 = _data$element2.props) == null ? void 0 : _data$element2.usersVisibility
    }, /*#__PURE__*/_react["default"].createElement(_DashboardDataProvider.DashboardDataProvider, null, /*#__PURE__*/_react["default"].createElement(_DashboardNavbar.DashboardNavbar, {
      dashboard: data
    }), /*#__PURE__*/_react["default"].createElement(_DashboardToolbar.DashboardToolbar, {
      dashboard: data,
      devices: devices,
      onReload: reload
    }), /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(DashboardContainer, {
      "data-allow-fullscreen": true,
      "data-testid": "DashboardScreen.Container"
    }, /*#__PURE__*/_react["default"].createElement(DashboardWrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.ComponentSize, null, function (_ref2) {
      var width = _ref2.width,
        height = _ref2.height;
      return /*#__PURE__*/_react["default"].createElement(_DashboardRenderer.DashboardRenderer, {
        style: {
          width: width,
          height: height
        }
      }, /*#__PURE__*/_react["default"].createElement(_Dashboard.Dashboard, {
        config: data,
        width: width,
        height: height,
        updateLayout: updateDashboardWidgetValue
      }));
    })))))));
  });
}));